(function () {
    'use strict';

    angular
        .module('ActionManager')
        .factory('handleActionCall', handleActionCall);

    function handleActionCall(ActionManager) {
        return function(actionName, actionOptions, actionData, panel, evtData) {
            if (actionName.split('-')[0] === 'ap') {
                return ActionManager(actionName, panel, actionOptions, actionData, evtData);
            }
            if (actionName.split('-')[0] !== 'ap') {
                return ActionManager(actionName, actionOptions, actionData, evtData);
            }
            return null;
        };
    }
})();